export const calculateRowsPerPage = (margin: number = 0): string => {
  const rowHeight = 50;
  const availableHeight = window.innerHeight - margin;
  return Math.max(1, Math.floor(availableHeight / rowHeight)).toString();
};
